module.exports = __webpack_public_path__ + "static/media/MINI-TEST-COUNT-2.788e867e.png";